import React from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Card } from "primereact/card";
import registrationService from "../../services/registration/registrationService";
import { useQuery } from "react-query";
import { L } from "../../lib/abpUtility";

const dummyData = [
  {
    licensePlate: "ABC123",
    fullName: "John Doe",
    phoneNumber: "+1234567890",
  },
  {
    licensePlate: "XYZ789",
    fullName: "Jane Smith",
    phoneNumber: "+1987654321",
  },
];

const phoneBodyTemplate = (rowData) => (
  <a
    href={`tel:${rowData.phoneNumber}`}
    style={{ color: "#2196F3", textDecoration: "none", fontWeight: 500 }}
  >
    {rowData.phoneNumber}
  </a>
);

const Parking = () => {
  const [licensePlateFilter, setLicensePlateFilter] = React.useState("");

  // Fake backend call
  const fetchParking = async (licensePlate) => {
    return await registrationService.getUserDetailsByLicensePlate({
        licensePlate: licensePlate
    });
  };

  const {
    data: results = [],
    isFetching,
    refetch,
  } = useQuery({
    queryKey: ["parking", licensePlateFilter],
    queryFn: () => fetchParking(licensePlateFilter),
    enabled: false,
  });

  const handleSearch = () => {
    setLicensePlateFilter(licensePlateFilter);
    refetch();
  };

  return (
    <div
      style={{
        maxWidth: 700,
        margin: "3rem auto",
        padding: "2.5rem",
        background: "#fff",
        borderRadius: 16,
        boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
      }}
    >
      <h2
        className="mb-4"
        style={{ textAlign: "center", color: "#2c3e50", fontWeight: 700 }}
      >
        {L("ParkingLookup")}
      </h2>
      <div
        className="p-inputgroup mb-4"
        style={{ maxWidth: 400, margin: "0 auto" }}
      >
        <span className="p-inputgroup-addon">
          <i className="pi pi-car" />
        </span>
        <InputText
          id="licensePlate"
          placeholder={L("EnterLicensePlate")}
          className="w-full"
          value={licensePlateFilter}
          onChange={(e) => setLicensePlateFilter(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleSearch();
          }}
        />
        <Button
          label={isFetching ? L("SearchWithThreeDot") : L("Search")}
          className="p-button-primary"
          style={{ minWidth: 100 }}
          onClick={handleSearch}
          disabled={isFetching}
        />
      </div>
      <div className="mt-5">
        <Card
          style={{
            boxShadow: "none",
            border: "1px solid #eee",
            borderRadius: 12,
          }}
        >
          <h3 style={{ marginBottom: 20, color: "#34495e" }}>{L("Results")}</h3>
          <DataTable
            value={results}
            className="p-datatable-sm"
            emptyMessage={isFetching ? L("SearchWithThreeDot") : L("NoResultsFound")}
            style={{ borderRadius: 8 }}
            loading={isFetching}
          >
            <Column
              field="licensePlate"
              header={L("LicensePlate")}
              style={{ minWidth: 120, fontWeight: 500 }}
            ></Column>
            <Column
              field="fullName"
              header={L("FullName")}
              style={{ minWidth: 200 }}
            ></Column>
            <Column
              field="phoneNumber"
              header={L("PhoneNumber")}
              body={phoneBodyTemplate}
              style={{ minWidth: 160 }}
            ></Column>
          </DataTable>
        </Card>
      </div>
    </div>
  );
};

export default Parking;
